import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'icon-holder',
    template: `
<icon *ngIf="!!icon" [i12]="true" [icon]="icon"></icon>
<div class="count" *ngIf="!!count">( {{ count }} )</div>
`,
    styleUrls: ['./icon-holder.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class IconHolderComponent {
  @Input() icon
  @Input() count
}